import {useMemo} from 'react';
import useWindowWidth from './useWindowWidth';

export default function useScreenIsSmall() {
  const windowWidth = useWindowWidth();
  return useMemo(() => windowWidth < 768, [windowWidth]);
}
